import Vue from 'vue'
import App from './App.vue'
import 'babel-polyfill'
import './lib/css'
import './lib/script'
import 'core-js/es/string'
import 'core-js/es/array'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import './registerServiceWorker'
import router from './router'
import store from './store'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import moment from 'moment'
// import Toast from 'vue-easy-toast'
import VueAWN from 'vue-awesome-notifications'
import 'vue-awesome-notifications/dist/styles/style.css'
// import 'vue-easy-toast/dist/vue-easy-toast-lite.min.js'
// import 'vue-easy-toast/dist/vue-easy-toast.css'
// import VueToast from 'vue-toast-notification'
// import 'vue-toast-notification/dist/theme-default.css'
// import firebase from 'firebase'
import ProgressBar from 'vuejs-progress-bar'
import { TextDecoder } from 'text-encoding'
if (!window.TextDecoder) {
  window.TextDecoder = TextDecoder
}
Vue.config.productionTip = false
// const config = {
//   apiKey: 'AIzaSyDye2wEwFwyublDqZKbWZEpKuOWxM6_dRw',
//   authDomain: 'screenitandroid.firebaseapp.com',
//   databaseURL: 'https://screenitandroid.firebaseio.com',
//   projectId: 'screenitandroid',
//   storageBucket: 'screenitandroid.appspot.com',
//   messagingSenderId: '630004979578',
//   appId: '1:630004979578:web:ae75e1e57ff8cdded168c3',
//   measurementId: 'G-2G6KR6V5N0'
// } // 4. Get Firebase Configuration
// firebase.initializeApp(config)

// const messaging = firebase.messaging()

// messaging.usePublicVapidKey('BJcHFBqmP7mZSMZ3UopmXSaXj6u_FW8Z39gybVYM9kbrHUEq8Sg7j1Xz7azSEJ-mbspn8GYGV2aSsJfRQXR_EPg')

// messaging.requestPermission().then(() => {
//   console.log('Notification permission granted.')
//   // Get Token
//   setTimeout(function () {
//     messaging.getToken().then((token) => {
//       console.log(token)
//       localStorage.setItem('push_token', JSON.stringify(token))
//     })
//   }, 3000)
// }).catch((err) => {
//   console.log('Unable to get permission to notify.', err)
// })
TimeAgo.addLocale(en)
Vue.prototype.$bus = EventBus
Vue.prototype.$http = axios
Vue.component('datetime', Datetime)
Vue.use(moment)
const optionsOverrides = {
  durations: {
    global: 3000
  },
  labels: {
    success: ''
  },
  position: 'bottom-right',
  icons: {
    prefix: "<i class='uil uil-check-circle'></i>",
    suffix: '',
    success: '',
    enabled: true,
    async: 'cof fa-spin'
  }
}
Vue.use(VueAWN, optionsOverrides)
const timeAgo = new TimeAgo('en-US')
Vue.filter('timeAgo', function (value) {
  return timeAgo.format(value - 24 * 60 * 60 * 1000)
})
Vue.filter('formatDatetime', function (value) {
  if (value) {
    return moment.utc(value).format('DD MMM YYYY hh:mm')
  }
})
Vue.filter('formatDatetimea', function (value) {
  if (value) {
    return moment.utc(value).format('DD MMM YYYY hh:mm A')
  }
})
Vue.filter('timeago', function (value) {
  if (moment(value).fromNow() === 'a minute ago' || moment(value).fromNow() === 'a few seconds ago') {
    return 'just now'
  } else if (moment(value).fromNow() === 'an hour ago') {
    return '1 hour ago'
  } else if (moment(value).fromNow() === 'a day ago') {
    return '1 day ago'
  } else {
    return moment(value).fromNow()
  }
})
Vue.filter('time', function (value) {
  if (value) {
    return moment.utc(value).format('hh:mm a')
  }
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment.utc(value).format('DD MMM YYYY')
  }
})
Vue.filter('getDay', function (value) {
  if (value) {
    return moment.utc(value).format('dddd')
  }
})
Vue.filter('formatDatetime', function (value) {
  if (value) {
    return moment.utc(value).format('DD-MMM-YYYY hh:mm')
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.use(ProgressBar)
